<template>
  <header>
    <h1 class="a11y-hidden">웨이브</h1>
    <div class="header-top">
      <h2 class="hd-title" v-html="getTitleText"></h2>
        <button class="btn-back" type="button">
          <span class="a11y-hidden">뒤로 가기</span>
          <span class="icon-back" @click.prevent="close"><back-button /></span>
        </button>
    </div>
  </header>

</template>

<script>
import { get } from 'lodash'
import { convertSpecialSymbols } from '@/common/directives'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'

export default {
  name: 'ViewMoreHeader',
  components: {
    BackButton
  },
  props: ['titleList', 'closeFn'],
  computed: {
    getTitleText () {
      const title = get(this.titleList, ['0', 'text'], '')
      // const icon = get(this.titleList, ['0', 'icon'], '')
      return convertSpecialSymbols(title)
    }
  },
  methods: {
    close () {
      this.closeFn()
    }
  }
}
</script>
